export default class ExtensionInfoModel {
  extensionInfoId: string = ''
  extensionId: string = ''
  name: string = ''
  stage: string = ''
  order: number = 0

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
